module.exports = __webpack_public_path__ + "img/rumberos_en_espana.63885602.webp";